<template>
  <div id="about" class="mt-5 pt-5">
    <div class="text-center mb-5">
      <img v-img-fallback="{ loading: imgBaseUrl + 'pixel.png', error: imgBaseUrl + 'kerlink-dark.png' }" :src="imgBaseUrl + 'logo/logo-dark.png'" alt="Logo">
    </div>

    <about-versions />
  </div>
</template>

<script>
import AboutVersions from '@/components/page/AboutVersions'

export default {
  titleKey: 'about',

  components: { AboutVersions }
}
</script>

<style scoped lang="scss">
  img {
    max-width: 260px;
    max-height: 200px;
  }
</style>
